import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-list',
  templateUrl: './listing-list.component.html',
  styleUrls: ['./listing-list.component.css']
})
export class ListingListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
